<res-base-modal modalTitle="System Status" [modalAutomationId]="modalAutomationId" [modalClass]="modalClass"
    [modalHelpIndex]="modalHelpIndex" [isPrimaryButtonHidden]="true" [secondaryButtonLabel]="'Close'"
    (closeButtonActionEmt)="closeModal()">

    <res-generic-grid [automationId]="modalAutomationId + '-grid'" [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage"
        [columnDefs]="columnDefs" [pagerVisible]="false" [showHeaderContextMenu]="false">
    </res-generic-grid>

</res-base-modal>